import { useApiClient } from '../../hooks/useApiClient';
import { UserStatus } from '../../types/UserStatus.type';

export const useUserStatusApi = () => {
  const apiClient = useApiClient();

  return {
    getUserStatuses: (): Promise<UserStatus[]> => apiClient(`/user_statuses/`),
  };
};
